import { MonthlyDatum, Segment } from './types'

export function getValueForSegment<X extends MonthlyDatum>(data: X, segment: Segment<X>) {
  if (typeof segment.value === 'string') {
    return data[segment.value]
  }
  return segment.value(data)
}

export const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
